import { TasksGroup } from '@common-models/task-group'
import { Stack } from '@mui/system'
import { _taskgroupsSelectors } from "@common-reducers/DBServiceThunks"
import { useAppSelector } from '@common-reducers/hooks/store.hook'
import { DEFAULT_ACCENT_COLOR } from '@common/theme/colors'
import classes from "../../group-header/group_header.module.scss" // Might not need this if we removed styling
import { CellProps } from '../cell-interface'
import { getGroupTaskListLength } from '@common-reducers/TaskSelectors'
import GroupMenu from '../../group-header/group-menu/GroupMenu'

export default function GroupMenuHeader({
    groupId
}: CellProps) {
    const tasksGroup = useAppSelector((state) => {
        return _taskgroupsSelectors.selectById(state, groupId ?? "")
    }) as TasksGroup | undefined;

    const groupTaskListLength = useAppSelector((state) => getGroupTaskListLength(state, groupId))

    const direction = useAppSelector((state) => state.UserReducer.direction);

    return (

        <Stack direction="row" alignItems="center">

            <Stack alignItems="center" className={classes.group_header_menu} style={{cursor: 'pointer', padding: '0 7px'}}>
                <GroupMenu groupId={groupId ?? ""} />
            </Stack>

            <Stack alignItems="center"
                style={{
                    height: '40px',
                    width: 24,
                    backgroundColor: tasksGroup?.colorAccent ?? DEFAULT_ACCENT_COLOR,
                    borderTopLeftRadius: direction === "ltr" ? 12 : undefined,
                    borderTopRightRadius: direction === "rtl" ? 12 : undefined,
                    borderBottomLeftRadius: (tasksGroup?.isCollapsed || groupTaskListLength === 0) ? 12 : 0,
                    position: 'relative',
                    insetInlineStart: (tasksGroup?.isCollapsed || groupTaskListLength === 0) ? 6 : 9 ,
      
                }}>
            </Stack>
        </Stack >

    )
}